import { get, writable } from 'svelte/store';
import { DossierCategoriesService } from '../../services/dossier-categories.service';
export const loading = writable(false);
export const editing = writable(false);
export const filter = writable(null);
export const pagination = writable(null);
export const records = writable([]);
export const record = writable(null);
let initialized = false;
export async function init() {
    if (!initialized) {
        initialized = true;
        editing.set(false);
        filter.set({ criteria: {}, params: null, sorting: "" });
        pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
        records.set([]);
        record.set(null);
    }
    await loadDossierCategories();
}
export async function loadDossierCategories() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await DossierCategoriesService.getDossierCategories(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    let item = {
        oid: 0,
        description: '',
        regionId: 0
    };
    record.set(item);
    editing.set(true);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    record.set(Object.assign({}, item));
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    await DossierCategoriesService.saveDossierCategory(_record);
    await loadDossierCategories();
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await DossierCategoriesService.deleteDossierCategory(item.oid);
    await loadDossierCategories();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    loadDossierCategories();
}
